import moment from 'moment';

export const EMPTY_VALUE = '—';

export const money = (value: number | null | undefined) =>
  value === null || value === undefined
    ? EMPTY_VALUE
    : value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

export const roundedMoney = (value: number) =>
  value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL', maximumFractionDigits: 0 });

export const count = (value: number | null | undefined, unit?: string | null) =>
  value === null || value === undefined
    ? EMPTY_VALUE
    : `${value.toLocaleString('pt-BR')}${unit ? ` ${unit}` : ''}`;

export const percent = (value: number | null | undefined) =>
  value === null || value === undefined ? EMPTY_VALUE : `${value.toLocaleString('pt-BR')}%`;

export const plural = (amount: number, singular: string, many: string) =>
  `${amount.toLocaleString('pt-BR')} ${amount === 1 ? singular : many}`;

const parseBackendDate = (value: string) =>
  moment.parseZone(value, [moment.ISO_8601, 'YYYY-MM-DD HH:mm:ss', 'YYYY-MM-DD HH:mm:ss.SSSSSS']);

const formatBackendDate = (value: string | null | undefined, pattern: string) => {
  if (!value) return EMPTY_VALUE;
  const parsed = parseBackendDate(value);
  return parsed.isValid() ? parsed.format(pattern) : EMPTY_VALUE;
};

export const dateBr = (value: string | null | undefined) => formatBackendDate(value, 'DD/MM/YYYY');

export const dateTimeBr = (value: string | null | undefined) =>
  formatBackendDate(value, 'DD/MM/YYYY [às] HH:mm');

export const sum = (values: Array<number | null>) => {
  const present = values.filter((value): value is number => value !== null);
  return present.length ? present.reduce((total, value) => total + value, 0) : null;
};
